import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { Client } from '../../admin/users/types';

type Payload = {
  familyId?: string;
  advisorUserId?: string;
  advised?: boolean;
};

export function useUpdateClient() {
  const queryClient = useQueryClient();

  const { mutateAsync, error, isLoading, reset } = useMutation({
    mutationFn: ({ id, values }: { id: string; values: Payload }) =>
      api.patch<Client>(`clients/${id}`, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clients'] });
    },
  });

  const updateClient = async (id: string, values: Payload) => {
    return mutateAsync({ id, values });
  };

  return {
    updateClient,
    error,
    isLoading,
    reset,
  };
}
